import React, { useState } from 'react';
import {
  GetAccountTransactionHistoryQueryVariables,
  useGetAccountTransactionHistoryQuery,
} from 'views/utils/graphql/graphql';

export const useGetAccountTransactionHisotry = (initValues: GetAccountTransactionHistoryQueryVariables) => {
  const [accountTransactionVariable, setAccountTransactionVariable] =
    useState<GetAccountTransactionHistoryQueryVariables>(initValues);

  const [accountTransactionHistory, getAccountTransactionHistory] = useGetAccountTransactionHistoryQuery({
    variables: accountTransactionVariable,
    requestPolicy: 'network-only',
  });
  return {
    accountTransactionHistory,

    setAccountTransactionVariable,
  };
};
